import { call, put } from 'typed-redux-saga';

import { NOTIFICATIONS_MAP, notify } from '../../../../shared/features/notifications/ps-notifications';
import { replace, SCREENS } from '../../../../shared/helpers/navigation';
import { disconnectConferenceAction } from '../../features/conference/slice';
import { DisconnectReason, NotificationId } from '../../types';
import { handleDisconnect } from './handle-disconnect';

export function* handleKick() {
    yield put(
        disconnectConferenceAction({
            source: DisconnectReason.KICK,
        })
    );
    yield call(replace, SCREENS.CREATE_CALL, {});
    yield call(handleDisconnect);
    yield put(notify(NOTIFICATIONS_MAP[NotificationId.MODERATION_KICK]()));
}
